'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function KPFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-qkttreui4", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-ovyjqb3so", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-exoryb43w" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-exoryb43w", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-qkttreui4)" }, /* @__PURE__ */ React.createElement("use", { fill: "#3d58db", xlinkHref: "#mantine-exoryb43w" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#c51918",
        stroke: "#f7fcff",
        strokeWidth: "2",
        d: "M-1 5h34v14H-1z",
        mask: "url(#mantine-ovyjqb3so)"
      }
    ), /* @__PURE__ */ React.createElement("g", { mask: "url(#mantine-ovyjqb3so)" }, /* @__PURE__ */ React.createElement("g", { transform: "translate(5 7)" }, /* @__PURE__ */ React.createElement("circle", { cx: "5", cy: "5", r: "5", fill: "#f7fcff" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#c51918",
        d: "M4.995 6.87L2.28 8.76l.958-3.167-2.637-2 3.309-.067L4.995.4l1.087 3.126 3.308.067-2.637 2 .958 3.167z"
      }
    )))))
  );
}

export { KPFlag };
//# sourceMappingURL=KP.mjs.map
